var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryOps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83203 20.0664V3.27337C1.83203 2.99089 1.9475 2.71997 2.15303 2.52023C2.35856 2.32048 2.63732 2.20826 2.92799 2.20826H6.93631C7.22697 2.20826 7.50574 2.32048 7.71127 2.52023C7.9168 2.71997 8.03226 2.99089 8.03226 3.27337V9.0855C9.06007 8.58944 10.0169 8.16367 10.9363 7.66896C11.4147 7.41215 11.7944 7.39863 12.277 7.6595C13.1963 8.15556 14.1546 8.58269 15.1629 9.07064V3.27202C15.1629 2.98953 15.2784 2.71862 15.4839 2.51887C15.6895 2.31913 15.9682 2.20691 16.2589 2.20691H20.27C20.5607 2.20691 20.8394 2.31913 21.045 2.51887C21.2505 2.71862 21.366 2.98953 21.366 3.27202V20.0664C21.3661 20.2064 21.3379 20.345 21.2829 20.4744C21.2279 20.6038 21.1472 20.7213 21.0454 20.8204C20.9437 20.9194 20.8228 20.998 20.6897 21.0516C20.5567 21.1052 20.414 21.1328 20.27 21.1328H2.92799C2.78395 21.1328 2.64132 21.1052 2.50826 21.0516C2.37521 20.998 2.25433 20.9194 2.15254 20.8204C2.05075 20.7213 1.97005 20.6038 1.91506 20.4744C1.86006 20.345 1.83185 20.2064 1.83203 20.0664Z",
    fill: "#656565"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3807_1902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6471 16.5032V14.4291H17.61V16.5032H15.536V17.5403H17.61V19.6143H18.6471V17.5403H20.7211V16.5032H18.6471ZM18.1285 22.2069C16.7533 22.2069 15.4345 21.6606 14.4621 20.6882C13.4897 19.7158 12.9434 18.3969 12.9434 17.0217C12.9434 15.6465 13.4897 14.3277 14.4621 13.3553C15.4345 12.3828 16.7533 11.8365 18.1285 11.8365C19.5037 11.8365 20.8226 12.3828 21.795 13.3553C22.7674 14.3277 23.3137 15.6465 23.3137 17.0217C23.3137 18.3969 22.7674 19.7158 21.795 20.6882C20.8226 21.6606 19.5037 22.2069 18.1285 22.2069Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3807_1902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.3704,
    height: 10.3704,
    fill: "white",
    transform: "translate(12.9434 11.8365)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryOps);
export default __webpack_public_path__ + "static/media/Inventory Ops.66338533c741013cc7d4d53a69388159.svg";
export { ForwardRef as ReactComponent };